import * as yup from 'yup'
import { IntlShape } from 'react-intl'

const PASSWORD_MIN_LENGTH = 8

export interface Values {
  password: string
  passwordRetype: string
}

export const schema = {
  password: '',
  passwordRetype: ''
}

export const validation = (
  intl: IntlShape
) => {
  const { formatMessage } = intl

  return (
    yup
      .object()
      .shape({
        password: yup
          .string()
          .required(formatMessage({ id: 'validation.passwordRequired' }))
          .min(PASSWORD_MIN_LENGTH, formatMessage({ id: 'validation.passwordMinLength' }))
          .matches(/[a-z]/, formatMessage({ id: 'validation.passwordLowercase' }))
          .matches(/[A-Z]/, formatMessage({ id: 'validation.passwordUppercase' }))
          .matches(/[0-9]/, formatMessage({ id: 'validation.passwordNumbers' })),

        passwordRetype: yup
          .string()
          .required(formatMessage({ id: 'validation.passwordRetype' }))
          .oneOf([yup.ref('password'), null], formatMessage({ id: 'validation.passwordRetypeMatches' }))
      })
  )
}
